import { ParentModel } from '@blueprint/frontend-basics'

export class PlatformUserStatsDto extends ParentModel {
  anonymousUserCount!: number
  loggedInUserCount!: number
  shopCount!: number
  teamCount!: number
}
